import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { IMAGES } from "../../lib/constants";
import { Lightbox } from "./Lightbox";

const spanClass = { tall: "md:col-span-5 md:row-span-2 aspect-[3/4] md:aspect-auto", wide: "md:col-span-7 aspect-[4/5]", half: "md:col-span-6 aspect-[4/5]" };

export const Portfolio = () => {
  const [active, setActive] = useState(null);
  const items = IMAGES.portfolio;
  return (
  <section id="portfolio" className="bg-[#0A0A0A] py-24 lg:py-32 px-6" data-testid="portfolio-section">
    <div className="max-w-7xl mx-auto">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-14">
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}>
          <p className="text-xs tracking-[0.3em] font-bold text-[#E60000] mb-3">PORTFÓLIO</p>
          <h2 className="font-display font-bold text-4xl md:text-5xl text-white leading-none">Tinta na pele</h2>
        </motion.div>
        <p className="text-sm text-white/50 max-w-xs font-light">Uma seleção do que sai das agulhas da Diggy.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-6 lg:gap-8">
        {items.map((item, i) => (
          <motion.button
            key={item.title}
            onClick={() => setActive(i)}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
            className={`img-frame group relative border border-white/10 text-left cursor-zoom-in ${spanClass[item.span]}`}
            data-testid={`portfolio-item-${i}`}
          >
            <img src={item.src} alt={item.title} loading="lazy" className="absolute inset-0 w-full h-full object-cover grayscale group-hover:grayscale-0" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A]/90 via-transparent to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-6 flex items-end justify-between">
              <div>
                <p className="text-[10px] tracking-[0.3em] font-bold text-[#E60000]">{item.tag}</p>
                <h3 className="font-display italic font-bold text-white text-2xl mt-1">{item.title}</h3>
              </div>
              <ArrowUpRight className="text-white/40 group-hover:text-[#E60000] transition-colors duration-300" size={22} />
            </div>
          </motion.button>
        ))}
      </div>
    </div>
    <Lightbox items={items} index={active} onClose={() => setActive(null)} onNav={setActive} />
  </section>
  );
};
